<template>
    <v-form>
        <v-text-field prepend-icon="person" name="login" label="Login" type="text" v-model="username"></v-text-field>
        <v-text-field prepend-icon="lock" name="password" label="Password" id="password" type="password" v-model="password" @keyup="keyUp"></v-text-field>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="submit" :loading="isLoggingIn" data-testing="basic-auth-login-button">{{$t('LOGIN_TITLE')}}</v-btn>
        </v-card-actions>
    </v-form>
</template>

<script lang="ts">
import Vue from "vue";
import { Base64 } from "js-base64";
import { Prop, Component } from "vue-property-decorator";
import { useErrorStore } from "@/stores/errorStore";
import { useAuthenticationStore } from "@/stores/authenticationStore";

@Component({})
export default class BasicAuth extends Vue {
    login = (payload: { provider: string, token: string }) => useAuthenticationStore().login(payload);
    @Prop() source;
    drawer = null;
    username = "";
    password = "";
    isLoggingIn = false;
    error = "";
    async keyUp(e) {
        if (e.keyCode === 13) this.submit();
    }
    async submit() {
        try {
            this.isLoggingIn = true;

            if (await this.login({ provider: "basic", token: Base64.encode(`${this.username}:${this.password}`) })) {
                useErrorStore().resetError();
                this.$emit("confirm");
            } else {
                useErrorStore().setError({ message: this.$t("LOGIN_INVALID_CREDENTIALS") });
            }
        } finally {
            this.isLoggingIn = false;
        }
    }
}
</script>
